import { render, staticRenderFns } from "./Banner1.vue?vue&type=template&id=f533c34e"
import script from "./Banner1.vue?vue&type=script&lang=js"
export * from "./Banner1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports